import { render, staticRenderFns } from "./CheckPosition.vue?vue&type=template&id=4947ebd8&"
import script from "./CheckPosition.vue?vue&type=script&lang=js&"
export * from "./CheckPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports